

































































































































































import { Component, Vue, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ConfigPerfilStore from '@/components/Configuracoes/store/ConfigPerfilStore'
import { timeout } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component
export default class ViewConfiguracaoPerfis extends Vue {
  readyState: boolean = false
  loadTable: boolean = false
  loadEdit: string = ''
  loadAdd: boolean = false
  loadDelete: boolean = false
  dialog: boolean = false
  addUsr: boolean = false
  dellUsr: boolean = false
  acao: string = 'Criar'

  get getConfigPerfilStore() {
    return getModule(ConfigPerfilStore, this.$store)
  }

  get perfis() {
    return this.getConfigPerfilStore.perfis
  }

  get loadingDeleteUser() {
    return this.loadDelete
  }

  set loadingDeleteUser(value: boolean) {
    this.loadDelete = value
  }

  get dellUser() {
    return this.dellUsr
  }

  set dellUser(value: boolean) {
    this.dellUsr = value
  }

  get addUser() {
    return this.addUsr
  }

  set addUser(value: boolean) {
    this.addUsr = value
  }

  get loadingCreateUser() {
    return this.loadAdd
  }

  set loadingCreateUser(value: boolean) {
    this.loadAdd = value
  }

  get loadingEditUser() {
    return this.loadEdit
  }

  set loadingEditUser(value: string) {
    this.loadEdit = value
  }

  get tableLoading() {
    return this.loadTable
  }

  get getTableHeader() {
    return this.getConfigPerfilStore.configPerfisTableHeader
  }

  showModalEditarUser(value: boolean) {
    this.dialog = value
  }

  async createUser(acao: string) {
    this.loadingCreateUser = true
    this.acao = acao
    await timeout(2000)
    this.addUser = true
    this.loadingCreateUser = false
  }

  async editUser(id: string, acao: string) {
    this.loadingEditUser = id
    this.acao = acao
    await timeout(2000)
    this.addUser = true
    this.loadingEditUser = ''
  }

  closeModal() {
    this.dialog = false
  }

  closeAddUser() {
    this.addUser = false
  }

  closeDellUser() {
    this.dellUser = false
  }

  dialogDell() {
    this.dellUser = true
  }

  async deleteUser(id: string) {
    this.loadingDeleteUser = true
    await timeout(1500)
    // this.getUsuarios.splice(this.getUsuarios.findIndex((e: any) => e.id === id), 1)

    if (this.loadingDeleteUser) {
      EventBus.$emit('setSnackbar', { show: true, text: `Usuário apagado com sucesso! ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: `Ocorreu um erro na requisição ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
    }

    this.loadingDeleteUser = false
    this.dellUser = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await timeout(1000)
    this.readyState = true
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
